import React from "react";
import styles from "./CategoryNav.module.css";
import { Link } from "react-router-dom";
import { GiCroissant, GiPieSlice, GiCookie } from "react-icons/gi";
import { TbBottle } from "react-icons/tb";
import { BiCake } from "react-icons/bi";
import { RiCake3Line } from "react-icons/ri";
import { SiCakephp } from "react-icons/si";
import { Accordion } from "react-bootstrap";
import { useAccordionButton } from "react-bootstrap/AccordionButton";

function CustomToggle({ children, eventKey }) {
  const decoratedOnClick = useAccordionButton(eventKey, () =>
    console.log("squish")
  );
  return <div onClick={decoratedOnClick}>{children}</div>;
}

function CategoryNav() {
  return (
    <div className={styles.categoryNav + ""}>
      <div className="container" id="categoryNavContainer">
        <div className={styles.navBody + " flex-row text-center pt-3"}>
          <div className={styles.category}>
            <Link className={styles.links} to="/products?category=Salado">
              <GiCroissant className={styles.categoryIcons} />
              <p className={styles.categoryName}>Salado</p>
            </Link>
          </div>
          <div className={styles.category + ""}>
            <Link className={styles.links} to="/products?category=Bebidas">
              <TbBottle className={styles.categoryIcons} />
              <p className={styles.categoryName}>Bebidas</p>
            </Link>
          </div>
          <div className={styles.category + ""}>
            <Link className={styles.links} to="/products?category=Tortas">
              <BiCake className={styles.categoryIcons} />
              <p className={styles.categoryName}>Tortas</p>
            </Link>
          </div>
          <div className={styles.category + ""}>
            <Link className={styles.links} to="/products?category=Porciones">
              <GiPieSlice className={styles.categoryIcons} />
              <p className={styles.categoryName}>Porciones</p>
            </Link>
          </div>
          <div className={styles.category + ""}>
            <Link className={styles.links} to="/products?category=Budines">
              <RiCake3Line className={styles.categoryIcons} />
              <p className={styles.categoryName}>Budines</p>
            </Link>
          </div>
          <div className={styles.category + ""}>
            <Link className={styles.links} to="/products?category=Cookies">
              <GiCookie className={styles.categoryIcons} />
              <p className={styles.categoryName}>Cookies</p>
            </Link>
          </div>
          <div className={styles.category + ""}>
            <Link className={styles.links} to="/products?category=Alfajores">
              <SiCakephp className={styles.categoryIcons} />
              <p className={styles.categoryName}>Alfajores</p>
            </Link>
          </div>
        </div>
      </div>
      <Accordion className={styles.accordion}>
        <Accordion.Item className="border border-0" eventKey="0">
          <Accordion.Header className={styles.accordionHeader}>
            Categorías
          </Accordion.Header>
          <CustomToggle>
            <Accordion.Body className="d-flex flex-row justify-content-between  pt-0">
              <div className="d-flex flex-column">
                <Link
                  className={styles.accordionLinks}
                  to="/products?category=salado"
                  eventkey="1"
                >
                  <GiCroissant className={styles.accordionIcons} />
                  Salado
                </Link>

                <Link
                  className={styles.accordionLinks}
                  to="/products?category=bebidas"
                >
                  <TbBottle className={styles.accordionIcons} />
                  Bebidas
                </Link>
              </div>
              <div className="d-flex flex-column">
                <Link
                  className={styles.accordionLinks}
                  to="/products?category=tortas"
                >
                  <BiCake className={styles.accordionIcons} />
                  Tortas
                </Link>

                <Link
                  className={styles.accordionLinks}
                  to="/products?category=porciones"
                >
                  <GiPieSlice className={styles.accordionIcons} />
                  Porciones
                </Link>

                <Link
                  className={styles.accordionLinks}
                  to="/products?category=alfajores"
                >
                  <SiCakephp className={styles.accordionIcons} />
                  Alfajores
                </Link>
              </div>
              <div className="d-flex flex-column">
                <Link
                  className={styles.accordionLinks}
                  to="/products?category=cookies"
                >
                  <GiCookie className={styles.accordionIcons} />
                  Cookies
                </Link>
                <Link
                  className={styles.accordionLinks}
                  to="/products?category=budines"
                >
                  <RiCake3Line className={styles.accordionIcons} />
                  Budines
                </Link>
              </div>
            </Accordion.Body>
          </CustomToggle>
        </Accordion.Item>
      </Accordion>
    </div>
  );
}

export default CategoryNav;
